import React, { useCallback } from 'react'

import { bool, node, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

const TRANSLATION_KEY_PREFIX = 'subscription_checkout.order_summary'
const RESTRUCTURE_KEY_PREFIX = 'subscription_checkout.plans_restructure.order_summary'
const TERMS_URL = 'https://www.cgtrader.com/pages/terms-and-conditions'
const PRIVACY_POLICY_URL = 'https://www.cgtrader.com/pages/privacy-policy'
const FAIR_USE_POLICY_URL = 'https://www.cgtrader.com/pages/subscription-fair-use-policy'

function LegalLink({ href, children }) {
  return (
    <a className="cgt-link-primary-accented" href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

LegalLink.propTypes = {
  href: string.isRequired,
  children: node.isRequired,
}

function LegalAgreement({ withFairUse = false, locale = 'en' }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const prefix = translate(`${TRANSLATION_KEY_PREFIX}.legal_agreement_prefix`)
  const termsLink = (
    <LegalLink href={TERMS_URL}>
      {translate(`${TRANSLATION_KEY_PREFIX}.legal_agreement_terms`)}
    </LegalLink>
  )
  const privacyLink = (
    <LegalLink href={PRIVACY_POLICY_URL}>
      {translate(`${TRANSLATION_KEY_PREFIX}.legal_agreement_privacy`)}
    </LegalLink>
  )

  if (!withFairUse) {
    return (
      <>
        {prefix}{' '}
        {termsLink}
        {' '}{translate(`${TRANSLATION_KEY_PREFIX}.legal_agreement_connector`)}{' '}
        {privacyLink}
        .
      </>
    )
  }

  return (
    <>
      {prefix}{' '}
      {termsLink}
      {translate(`${RESTRUCTURE_KEY_PREFIX}.legal_privacy_separator`)}{' '}
      {privacyLink}
      {' '}{translate(`${RESTRUCTURE_KEY_PREFIX}.legal_fair_use_connector`)}{' '}
      <LegalLink href={FAIR_USE_POLICY_URL}>{translate(`${RESTRUCTURE_KEY_PREFIX}.legal_fair_use`)}</LegalLink>
      .
    </>
  )
}

LegalAgreement.propTypes = {
  withFairUse: bool,
  locale: string,
}

export default LegalAgreement
